import { Component } from "react";

// catches render-time crashes anywhere under the route tree so a bad show
// or a stale user object never produces a fully-black page. previously
// surfaced as: "pages briefly load and then the screen goes completely
// black" on mobile non-admin sessions.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // surface the error in console so we can grab it from real devices
    // via remote inspector / sentry later.
    console.error("the lobby — render crash:", error, info?.componentStack);
  }

  handleReset = () => {
    // wipe persisted store state — most common cause of recurring crash
    // is a stale localStorage shape from a previous prototype build.
    try {
      localStorage.removeItem("the-lobby-store");
      localStorage.removeItem("the-lobby-token");
    } catch {
      /* ignore */
    }
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main
        data-testid="error-boundary"
        className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 text-center"
      >
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-acid mb-3">
          something broke
        </div>
        <h1 className="font-display text-4xl leading-tight">
          the lobby tripped<span className="text-acid">.</span>
        </h1>
        <p className="font-mono text-xs text-white/60 mt-3 max-w-sm leading-relaxed">
          a render error knocked the page out. tap below to reset your
          local cache and try again.
        </p>
        <button
          data-testid="error-boundary-reset"
          onClick={this.handleReset}
          className="mt-6 font-mono text-xs lowercase border-2 border-acid text-acid px-4 py-3 hover:bg-acid hover:text-black transition-colors"
        >
          reset & reload
        </button>
        {this.state.error?.message && (
          <pre className="mt-6 font-mono text-[10px] text-white/30 max-w-md whitespace-pre-wrap break-words">
            {String(this.state.error.message).slice(0, 240)}
          </pre>
        )}
      </main>
    );
  }
}
